import removeGlobalFormError from './helpers'

const formCheckbox = document.querySelectorAll('.form-field-checkbox')


formCheckbox.forEach((inputField) => {

  const input = inputField.querySelector('input')

  input.addEventListener('change', () => {
    inputField.classList.remove('has-error')
    removeGlobalFormError(inputField)
  })

})
